module.exports = __webpack_public_path__ + "img/new15.000b5c91.jpg";